import useId from '../utils/useId';
import * as React from 'react';
export const targobankSvg = React.forwardRef(function targobankSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_targobank__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16 4.818c1.397-.043 2.866 1.455 2.91 2.91.043 1.454-1.513 2.865-2.91 2.909-1.396.043-2.865-1.455-2.909-2.91-.043-1.454 1.513-2.865 2.91-2.909Z',
        fill: '#BC123D',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm8.29 11.917 4.32 4.523c.568.597 1.485.567 2.11-.087.625-.655.669-1.615.087-2.226l-4.334-4.523c-.553-.596-1.499-.567-2.11.087a1.615 1.615 0 0 0-.072 2.226Zm15.245-.015-4.32 4.538v-.014c-.582.61-1.499.582-2.124-.073-.611-.655-.655-1.63-.073-2.226l4.32-4.523c.553-.596 1.498-.567 2.11.087.625.64.64 1.63.087 2.211Z',
        fill: '#8EA5C4',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm14.778 21.502-4.407 4.626c-.582.61-1.513.596-2.138-.059-.611-.654-.64-1.629-.058-2.24l4.407-4.625c.567-.611 1.513-.596 2.138.058.611.64.64 1.63.058 2.24Zm2.284 0 4.393 4.626c.596.61 1.512.596 2.138-.059.625-.654.64-1.629.058-2.24l-4.393-4.625c-.581-.611-1.527-.596-2.138.058-.625.64-.64 1.63-.058 2.24Z',
        fill: '#002D5E',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_targobank__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(7.756 4.817)',
          d: 'M0 0h16.319v21.756H0z',
        }),
      ),
    ),
  );
});
targobankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var targobank = {
  category: 'brand',
  colorable: false,
  name: 'targobank',
  svg: targobankSvg,
};
